import ZonesView from "../../zones/ZonesView";
import SectionHeader from "../../SectionHeader";
import {ICity, IConstants, ISection} from "../../model/B2CInfo";
import './ZonesItem.css'
import MobileSectionHeader from "../../MobileSectionHeader";
import MobileShowMore from "../../common/MobileShowMore";
import {Link} from "react-router-dom";
import React from "react";

interface IZonesItemProps {
    section: ISection
    mobile: boolean
    constants: IConstants
    city: ICity,
    onShowZones: () => void
}

interface IZonesItemData {
    image: string
}

export default function ZonesItem(props: IZonesItemProps) {
    if (props.mobile) {
        let data = (props.section.data as IZonesItemData)
        return <div className="Zones_item_container_mobile">
            <MobileSectionHeader section={props.section}/>
            <div className="Zones_item_container_mobile__image"
                 style={{height: `${(373 * window.innerWidth / 375)}px`}}>
                {/*<img src={data.image}/>*/}
                <div className="mobile_container">
                    <img src={data.image}/>
                    <Link to={"/drive/b2c/zones/"} className="Zones_item_container_mobile__show_more">
                        <MobileShowMore title="Посмотреть карту" onClick={(e) => {
                        }}/>
                    </Link>
                </div>
                <div className="Car_card_shadow"/>

            </div>
        </div>
    } else {
        return <div className="Zones_item_container">
            <SectionHeader section={props.section}/>
            <ZonesView city={props.city} constants={props.constants}/>
        </div>
    }
}